// extracted by mini-css-extract-plugin
module.exports = {"section":"question-module--section--uEuaQ","title":"question-module--title--As9GY"};